import { render, staticRenderFns } from "./DiseaseApproveByDecanat.vue?vue&type=template&id=29ad61f7&scoped=true&"
import script from "./DiseaseApproveByDecanat.vue?vue&type=script&lang=js&"
export * from "./DiseaseApproveByDecanat.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseApproveByDecanat.vue?vue&type=style&index=0&id=29ad61f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ad61f7",
  null
  
)

export default component.exports